import * as yup from 'yup';

export const sanitizeFilename = (name: string): string => {
  const withoutDiacritics = name.normalize('NFD').replace(/\p{M}/gu, '');
  const ext = withoutDiacritics.lastIndexOf('.') !== -1
    ? withoutDiacritics.slice(withoutDiacritics.lastIndexOf('.'))
    : '';
  const base = withoutDiacritics.slice(0, withoutDiacritics.length - ext.length);
  const safeBase = base.replace(/[^a-zA-Z0-9_-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  const safeExt = ext.replace(/[^a-zA-Z0-9.]/g, '');
  return (safeBase || 'file') + safeExt;
};

export const ALLOWED_MIME_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
export const ALLOWED_EXTENSIONS = ['.pdf', '.png', '.jpg', '.jpeg'];
export const FILE_ACCEPT = ALLOWED_EXTENSIONS.join(',');

const fileTypeErrorkey = 'users.create.inputs.fileType.error';

const validateFileType = (file: File | null): boolean => {
  if (!file) return false;
  const name = file.name?.toLowerCase?.() ?? '';
  const type = (file as File).type ?? '';

  const hasValidExtensions = ALLOWED_EXTENSIONS.some(ext => name.endsWith(ext));
  const hasValidFileTypes = ALLOWED_MIME_TYPES.includes(type);

  return hasValidExtensions && hasValidFileTypes;
};

export const fileValidation = () =>
  yup
    .mixed<File>()
    .nullable()
    .test('fileType', fileTypeErrorkey, (value) => {
      if (!value) {
        return true;
      }
      const file = toFile(value);
      return validateFileType(file);
    });
